var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.679392
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78767 12.7905C4.89802 14.2362 5.95325 15.5729 8.0662 15.5729C9.66902 15.5729 10.4332 14.7195 10.4332 13.7567C10.4332 12.9419 9.88723 12.2725 8.50262 11.9745L6.13523 11.4207C2.67679 10.6415 1.11061 8.52731 1.11061 5.97088C1.11061 2.70775 3.95106 0 7.8097 0C12.9088 0 14.6208 3.29876 14.8382 5.2667L10.7984 6.19261C10.6514 5.1179 9.88723 3.74516 7.84757 3.74516C6.57289 3.74516 5.55306 4.52479 5.55306 5.56178C5.55306 6.45039 6.20811 7.00619 7.1917 7.1923L9.74066 7.74852C13.2724 8.49001 15.0576 10.6784 15.0576 13.3468C15.0576 16.3148 12.8001 19.3545 8.10243 19.3545C2.71261 19.3545 0.856165 15.7938 0.636719 13.719L4.78767 12.7905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0473 4.59504C26.4236 4.59504 27.54 6.14799 27.9716 7.66627L32.2567 6.18562C31.6815 3.85091 29.9504 1.52213 27.0338 0.538269L22.9434 4.74176C23.2997 4.65593 23.6667 4.59504 24.0473 4.59504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0826 14.8435C21.6351 14.8435 19.5456 12.9908 19.5456 9.70058C19.5456 9.06934 19.6427 8.51039 19.7818 7.9895L15.2227 12.6758C16.3978 16.659 19.8522 19.3548 24.0826 19.3548C28.7985 19.3548 31.5698 16.2464 32.3635 13.2149L28.1504 11.7727C27.7533 13.1777 26.53 14.8435 24.0826 14.8435Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScMobile);
export default __webpack_public_path__ + "static/media/sc-mobile.80a56c62.svg";
export { ForwardRef as ReactComponent };